import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const MobileProjectContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 70vh;
  gap: 24px;
  .icon-mobile-web {
    height: 100px;
    width: 148.13px;
  }

  .button-copy-url {
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${COLOR.darkBlue};
    background-color: ${COLOR.yellow.default};
    border-radius: 12px;
    height: 48px;
    width: 100%;
  }

  .copy-icon {
    color: ${COLOR.darkBlue};
    width: 24px;
    height: 24px;
  }

  .checked-icon {
    border-radius: 50%;
    background-color: ${COLOR.darkBlue};
    color: ${COLOR.yellow.default};
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .btn-copy-text {
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    word-wrap: break-word;
    text-transform: none;
  }
  .noti-mobile-project {
    color: ${COLOR.darkGray};
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    word-wrap: break-word;
    text-align: center;
    padding: 8px 8px;
  }
`;
